import React, { FC, useMemo } from 'react';
import { Table } from 'antd';

import { getColumns } from '../utils/getColumns';
import { ExportsProps } from '../interface/exports.interface';
import { dynamicPagination } from '../../../../../utils/common/dynamicPagination';
import {
    CommonFiltersProps,
    CommonTableProps,
} from '../../../interfaces/common.interface';

export const ExportsTable: FC<
    CommonTableProps<ExportsProps, CommonFiltersProps>
> = ({ source, loading, filters, updateFilters }) => {
    const pagination = useMemo(
        () => dynamicPagination(filters, updateFilters, source?.total, 'Всего'),
        [filters, updateFilters, source?.total]
    );

    return (
        <Table
            loading={loading}
            pagination={pagination}
            dataSource={source.items || []}
            rowKey={record => record.id}
            columns={getColumns()}
        />
    );
};
